import React from "react";
import styles from "../../../Admin/widget/WidgetAnalytics.module.css";
import { FiExternalLink } from "react-icons/fi";

const fmt = (n) => n.toLocaleString();

const SkeletonTopPages = () => (
  <div className={`${styles.skeletonSectionCard} mb-4`}>
    <div className={styles.skeletonSectionHeader}>
      <div>
        <div className={styles.skeleton} style={{ height: "14px", width: "100px", marginBottom: "6px" }} />
        <div className={styles.skeleton} style={{ height: "10px", width: "260px" }} />
      </div>
    </div>
    <div className={styles.skeletonTableHeader}>
      {[180, 70, 80, 90, 110, 90].map((w, i) => (
        <div key={i} className={styles.skeleton} style={{ width: w, height: "10px", flexShrink: 0 }} />
      ))}
    </div>
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className={styles.skeletonTableRow}>
        <div className={styles.skeleton} style={{ width: "200px", height: "13px", flexShrink: 0 }} />
        <div className={styles.skeleton} style={{ width: "55px",  height: "13px", flexShrink: 0 }} />
        <div className={styles.skeleton} style={{ width: "65px",  height: "13px", flexShrink: 0 }} />
        <div className={styles.skeleton} style={{ width: "65px",  height: "13px", flexShrink: 0 }} />
        <div className={styles.skeletonClickCell}>
          <div className={styles.skeleton} style={{ height: "13px", width: "100%" }} />
          <div className={styles.skeleton} style={{ height: "3px", width: "70px", borderRadius: "2px" }} />
        </div>
        <div className={styles.skeletonConvCell}>
          <div className={styles.skeleton} style={{ height: "13px", width: "36px" }} />
          <div className={styles.skeleton} style={{ height: "5px", flex: 1, borderRadius: "3px" }} />
        </div>
      </div>
    ))}
    <div className={styles.skeletonFooterRow}>
      <div className={styles.skeleton} style={{ height: "12px", width: "130px" }} />
    </div>
  </div>
);

const TopPages = ({ pages, loading }) => {
  if (loading) return <SkeletonTopPages />;

  return (
    <div className={`${styles.sectionCard} mb-4`}>
      <div className={styles.sectionCardHeader}>
        <div>
          <div className={styles.sectionTitle}>Top Pages</div>
          <div className={styles.sectionSubtitle}>
            Performance analytics of WhatsApp widgets embedded across website pages
          </div>
        </div>
      </div>

      <div className={styles.tableResponsive}>
        <table className={styles.pagesTable}>
          <thead>
            <tr>
              <th>PAGE URL</th>
              <th>VISITORS</th>
              <th>PAGE VIEWS</th>
              <th>WIDGET OPENS</th>
              <th>WHATSAPP CLICKS</th>
              <th>CONVERSION %</th>
            </tr>
          </thead>
          <tbody>
            {pages.length === 0 ? (
              <tr>
                <td colSpan={6} className={styles.tableEmptyCell}>No data available for this period</td>
              </tr>
            ) : pages.map((row, i) => (
              <tr key={i}>
                <td>
                  <span className={styles.pageUrl} title={row.url}>
                    <FiExternalLink className={styles.pageUrlIcon} />
                    <span className={styles.pageUrlText}>{row.url}</span>
                  </span>
                </td>
                <td><strong style={{ color: "#0f172a" }}>{fmt(row.visitors)}</strong></td>
                <td style={{ color: "#475569" }}>{fmt(row.pageViews)}</td>
                <td><span className={styles.widgetOpenValue}>{fmt(row.widgetOpens)}</span></td>
                <td>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <span style={{ fontSize: "12.5px", fontWeight: 600, color: "#334155" }}>{fmt(row.waClicks)}</span>
                    <div className={styles.clickBar}>
                      <div className={styles.clickBarFill} style={{ width: `${Math.min(100, (row.waClicks / 5000) * 100)}%` }} />
                    </div>
                  </div>
                </td>
                <td>
                  <div className={styles.conversionCell}>
                    <span className={styles.conversionPct}>{row.conversion}%</span>
                    <div className={styles.conversionBar}>
                      <div className={styles.conversionBarFill} style={{ width: `${Math.min(100, row.conversion * 2)}%` }} />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.tableFooter}>
        <span className={styles.tableFooterInfo}>Showing top {pages.length} pages</span>
      </div>
    </div>
  );
};

export default TopPages;
